export default "__VITE_ASSET__8X5W23y___"